import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import truncate from "truncate-html";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function formatDate(dateStr) {
  const date = new Date(dateStr);

  const month = date
    .toLocaleString("default", { month: "short" })
    .toUpperCase();

  const day = date.getDate();
  const year = date.getFullYear();

  return { month, day, year };
}
const TruncateHtml = (htmlString, length) => {
  return truncate(htmlString, length, { byWords: true });
};

function PublicAnnounceSection({
  datacontent,
  initialDownloadData,
  initialPagination,
  id,
}) {
  const [newsList, setNewsList] = useState(datacontent || []);
  const [newsDownloadList, setNewsDownloadList] = useState(
    initialDownloadData || [],
  );
  // const [selectedNews, setSelectedNews] = useState(datacontent?.[0] || null);
  // const [selectedNewsDownload, setSelectedNewsDownload] = useState(
  //   initialDownloadData?.[0] || null,
  // );

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(
    initialPagination || {
      current_page: 1,
      last_page: 1,
    },
  );
  const [pageDownload, setPageDownload] = useState(1);
  const [paginationDownload, setPaginationDownload] = useState(
    initialPagination || {
      current_page: 1,
      last_page: 1,
    },
  );
  const [loading, setLoading] = useState(false);
  const headerTitle =
    datacontent?.[0]?.title?.length > 0 ? datacontent[0].title : "Blank Page";

  useEffect(() => {
    setNewsList(datacontent || []);
    setNewsDownloadList(initialDownloadData || []);

    // setSelectedNews(datacontent?.[0] || null);
    // setSelectedNewsDownload(initialDownloadData?.[0] || null);
  }, [datacontent, initialDownloadData]);

  useEffect(() => {
    //if (page === 1) return;

    fetchNews();
  }, [page, pageDownload]);

  const fetchNews = async () => {
    setLoading(true);

    try {
      // axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}posdata?pageName[eq]=${id}&columes[eq]=title_show_echo_01&ministry[eq]=1&status02[eq]=publish&status[eq]=Public&visibility[eq]=Public&display01[eq]=1&page=${page}&per_page=1`,
        ),
        axios.get(
          `${BASE_URL}posdata?columes[eq]=title_show_echo_01wa&ministry[eq]=1&status02[eq]=publish&status[eq]=Public&visibility[eq]=Public&page=${pageDownload}&per_page=10`,
        ),
      ]);

      const [PublicAnnounceSec, DownloadDataSec] = responses;

      const allData = PublicAnnounceSec?.data?.allData || [];
      const downloadData = DownloadDataSec?.data?.allData || [];

      setNewsList(allData);
      setNewsDownloadList(downloadData);

      // auto select first news
      // setSelectedNews(allData[0] || null);
      // setSelectedNewsDownload(downloadData[0] || null);

      setPagination(
        PublicAnnounceSec?.data?.pagination || {
          current_page: 1,
          last_page: 1,
        },
      );

      setPaginationDownload(
        DownloadDataSec?.data?.pagination || {
          current_page: 1,
          last_page: 1,
        },
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // const { month, day, year } = selectedNews?.daterqw
  //   ? formatDate(selectedNews.daterqw)
  //   : { month: "", day: "", year: "" };

  //if (!selectedNews) return null;

  return (
    <section id="portfolio-details" className="portfolio-details section light-background">
      <div className="container section-title" data-aos="fade-up">
        <p>
          <span className="description-title">{headerTitle}</span>
        </p>
      </div>

      <div className="container" data-aos="fade-up">
        <div className="row gy-4">
          {/* ANNOUNCEMENTS */}
          <div
            className={
              newsList[0]?.aligment009?.toLowerCase() === "center"
                ? "col-lg-8"
                : "col-lg-12"
            }
          >
            {newsList.map((item, index) => {
              // const { month, day, year } = formatDate(item.daterqw);

              // ✅ FIXED: alignment per item
              const alignment = item?.aligment009?.toLowerCase();
              const isLeft = alignment === "left";
              const isRight = alignment === "right";
              const isCenter = alignment === "center";

              return (
                <div key={item.id || index} className="mb-4 text-secondary">
                  {/* LEFT */}
                  {isLeft && (
                    <div className="row align-items-start">
                      <div className="col-lg-6">
                        {item.passport &&
                          item.passport !== "undefined" &&
                          item.passport !== "null" &&
                          item.passport.trim() !== "" && (
                            <>
                              <img
                                loading="lazy"
                                decoding="async"
                                src={`${BACKEND_URL}upload/${item.passport}`}
                                alt={item.title || "Image"}
                                className="img-fluid w-100 mb-3"
                                style={{
                                  objectFit: "cover",
                                }}
                              />
                            </>
                          )}
                      </div>
                      <div className="col-lg-6">
                        <HTMLDisplay html={item.story01} type="title" />
                        <p>
                          <HTMLDisplay html={item.story01} type="body" />
                        </p>
                      </div>
                    </div>
                  )}

                  {/* RIGHT */}
                  {isRight && (
                    <div className="row align-items-start">
                      <div className="col-lg-6 order-lg-2">
                        {item.passport &&
                          item.passport !== "undefined" &&
                          item.passport !== "null" &&
                          item.passport.trim() !== "" && (
                            <>
                              <img
                                loading="lazy"
                                decoding="async"
                                src={`${BACKEND_URL}upload/${item.passport}`}
                                alt={item.title || "Image"}
                                className="img-fluid w-100 mb-3"
                                style={{
                                  objectFit: "cover",
                                }}
                              />
                            </>
                          )}
                      </div>
                      <div className="col-lg-6 order-lg-1">
                        <HTMLDisplay html={item.story01} type="title" />
                        <p>
                          <HTMLDisplay html={item.story01} type="body" />
                        </p>
                      </div>
                    </div>
                  )}

                  {/* CENTER */}
                  {isCenter && (
                    <div>
                      {" "}
                      {item.passport &&
                        item.passport !== "undefined" &&
                        item.passport !== "null" &&
                        item.passport.trim() !== "" && (
                          <>
                            <img
                              loading="lazy"
                              decoding="async"
                              src={`${BACKEND_URL}upload/${item.passport}`}
                              alt={item.title || "Image"}
                              className="img-fluid w-100 mb-3"
                              style={{
                                objectFit: "cover",
                              }}
                            />
                          </>
                        )}
                      <HTMLDisplay html={item.story01} type="title" />
                      <p>
                        <HTMLDisplay html={item.story01} type="body" />
                      </p>
                    </div>
                  )}
                </div>
              );
            })}

            {/* PAGINATION */}

            {/* Pagination Controls */}
            <div className="d-flex justify-content-end align-items-center mt-3">
              <button
                className="btn btn-dark me-2"
                onClick={() => setPage(1)}
                disabled={pagination?.current_page === 1}
              >
                «
              </button>

              <button
                className="btn btn-dark me-2"
                onClick={() => setPage(pagination?.current_page - 1)}
                disabled={pagination?.current_page === 1}
              >
                ‹
              </button>

              <span className="me-2">
                Page {pagination?.current_page} of {pagination?.last_page}
              </span>

              <button
                className="btn btn-dark me-2"
                onClick={() => setPage(pagination?.current_page + 1)}
                disabled={pagination?.current_page === pagination?.last_page}
              >
                ›
              </button>

              <button
                className="btn btn-dark"
                onClick={() => setPage(pagination?.last_page)}
                disabled={pagination?.current_page === pagination?.last_page}
              >
                »
              </button>
            </div>
          </div>

          {/* DOWNLOADS (OPTIONAL - based on FIRST item center) */}
          {datacontent?.[0]?.aligment009?.toLowerCase() === "center" && (
            <div className="col-lg-4">
              <div
                className="portfolio-info"
                aria-label="Downloadable resource"
              >
                <h3>Downloadable Resources</h3>
                <ul className=" mb-0">
                  {newsDownloadList.map((file, i) => (
                    <li
                      key={i}
                      className="d-flex align-items-center justify-content-between gap-2 mb-2"
                    >
                      <div className="d-flex align-items-center gap-2">
                        <i className="fas fa-file-pdf fs-5 text-danger"></i>

                        <Link
                          to={`${BACKEND_URL}upload/${file.addressLink}`}
                          download
                          className="text-capitalize text-decoration-none"
                        >
                          {TruncateHtml(file.title, 12)}
                        </Link>
                      </div>

                      <i className="fas fa-download fs-5 download-icon"></i>
                    </li>
                  ))}
                </ul>

                {/* DOWNLOAD PAGINATION */}

                {/* Pagination Controls */}
                <div className="d-flex justify-content-end align-items-center mt-3">
                  <button
                    className="btn btn-dark me-2"
                    onClick={() => setPageDownload(1)}
                    disabled={paginationDownload?.current_page === 1}
                  >
                    «
                  </button>

                  <button
                    className="btn btn-dark me-2"
                    onClick={() =>
                      setPageDownload(paginationDownload?.current_page - 1)
                    }
                    disabled={paginationDownload?.current_page === 1}
                  >
                    ‹
                  </button>

                  <span className="me-2">
                    Page {paginationDownload?.current_page} of{" "}
                    {paginationDownload?.last_page}
                  </span>

                  <button
                    className="btn btn-dark me-2"
                    onClick={() =>
                      setPageDownload(paginationDownload?.current_page + 1)
                    }
                    disabled={
                      paginationDownload?.current_page ===
                      paginationDownload?.last_page
                    }
                  >
                    ›
                  </button>

                  <button
                    className="btn btn-dark"
                    onClick={() =>
                      setPageDownload(paginationDownload?.last_page)
                    }
                    disabled={
                      paginationDownload?.current_page ===
                      paginationDownload?.last_page
                    }
                  >
                    »
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default React.memo(PublicAnnounceSection);
